import { EmbeddedRecordsMixin } from '@ember-data/serializer/rest';
import ApplicationSerializer from 'lumen/serializers/application';

// eslint-disable-next-line @typescript-eslint/no-unsafe-call
export default class TotalRevenueBreakdownItemSerializer extends ApplicationSerializer.extend(
  EmbeddedRecordsMixin,
) {
  attrs = {
    referenceValues: { embedded: 'always' },
    sources: { embedded: 'always' },
    trendDays: { embedded: 'always' },
    trendWeeks: { embedded: 'always' },
    trendMonths: { embedded: 'always' },
  };
}
